<div class="box-layout-container" [class.no-padding]="!config?.isAppOpened">
  <!-- Sub-header for Artifacts mode -->
  <app-artifacts-bar class="artifacts-bar" *ngIf="config?.isAppOpened"></app-artifacts-bar>

  <div class="box-card">
    <div class="box-content" [@boxState]="isContentCollapsed ? 'collapsed' : 'expanded'">
      <ng-content></ng-content>
    </div>
    <div class="box-toolbar" [class.collapsed-view]="isContentCollapsed">
      <ng-content select="[toolbar]"></ng-content>
    </div>
  </div>
</div>
